import React, { useEffect, useState } from "react";
import { View, TouchableOpacity } from "react-native";

import Modal from "./Modal";
import Text from "component/typography/Text";
import Icon from "component/typography/Icon";
import Input from "component/input/Input";
import Empty from "component/section/Empty";
import Error from "component/section/Error";

import Loading from "component/section/Loading";
import InfinityList from "component/section/InfinityList";

import { styles } from "./styles";
import { sizes, colors, strings } from "asset/constant";

import { useFlag } from "hook";
import { liveSearchInput, mq } from "utils";

import { useCities } from "client/api";
import ModalInfinityList from "./ModalInfinityList";

let timer: ReturnType<typeof setTimeout>;

export default function CityPicker(props: PickerT) {
  const { id, value, onSelect, error, hideError, onPress } = props;
  const val = value as LocationT;

  const [name, setName] = useState("");
  const {
    isError,
    error: citiesError,
    isRefetching,
    refetch,
    isLoading: citiesFetching,
    data: cities,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useCities({ name, id });

  const { flg: modal, on: show, off: hide } = useFlag();
  const { flg: typing, on: startTyping, off: stopTyping } = useFlag();

  const _onHide = () => {
    setName("");
    hide();
  };

  const [valueState, setValueState] = useState<LocationT | undefined>();

  useEffect(() => {
    setValueState(val);
  }, [val]);

  useEffect(() => {
    id && refetch();
  }, [id, refetch]);

  const _renderItem = (items: []) => {
    return items.map((city: LocationT, key: number) => (
      <React.Fragment key={String(key)}>
        <TouchableOpacity
          style={styles.item}
          onPress={() => {
            onSelect && onSelect(city);
            setName("");
            setValueState(city);
            hide();
          }}
        >
          <Text>{city.text}</Text>
        </TouchableOpacity>
        <View style={styles.itemSeparator} />
      </React.Fragment>
    ));
  };

  const _renderList = () => {
    if (citiesFetching || typing) {
      return (
        <View style={{ marginTop: mq(20) }}>
          <Loading />
        </View>
      );
    }

    if (isError) {
      return (
        <Error error={citiesError} reset={refetch} loading={isRefetching} />
      );
    }

    if (cities?.pages?.[0]?.data?.data?.length === 0) {
      return <Empty message={strings.not_any_item_to_show} />;
    }

    return (
      <InfinityList
        onRefresh={refetch}
        responseData={cities}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        renderItemList={_renderItem}
      />
    );
  };

  return (
    <>
      <>
        <TouchableOpacity
          onPress={onPress ?? show}
          activeOpacity={sizes.tapOpacity}
          style={{ ...styles.container }}
        >
          <View style={{ ...styles.iconContainer, width: mq(45) }}>
            <Icon name="down" />
          </View>
          <View style={styles.textContainer}>
            <Text
              weight="bold"
              color={
                valueState?.text ? colors.text.normal : colors.text.placeholder
              }
            >
              {valueState?.text || strings.select_city}
            </Text>
          </View>

          <View style={{ ...styles.iconContainer, width: mq(45) }}>
            <Icon size={mq(22)} type="simpleLine" name="map" />
          </View>
        </TouchableOpacity>

        {!hideError && (
          <View style={styles.errorContainer}>
            <Text size={"xs"} color={colors.danger}>
              {error}
            </Text>
          </View>
        )}
      </>

      <ModalInfinityList visible={modal} close={_onHide}>
        <View style={styles.listSearchContainer}>
          <Input
            hideError
            icon={{ name: "search1" }}
            placeholder={strings.search}
            onChangeText={(inputName) => {
              liveSearchInput(
                inputName,
                name,
                setName,
                timer,
                startTyping,
                stopTyping
              );
              refetch();
            }}
          />
        </View>
        {_renderList()}
      </ModalInfinityList>
    </>
  );
}
